import Subtitle from '../Subtitle'

const NoData = ({ msg }) => {
  return <Subtitle title={msg || 'Немає даних'} />
}
export default NoData
